import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Member } from '../../../../../types/member';
import { MatchingHistory } from '../../../../../types/matching';
import { MainButton, SubButton } from '../../../../../component/button';
import { setIsAccept } from '../../../../../api/matchingHistoryAPI';
import useAuth from '../../../../../hook/useAuth';
import { useMobile } from '../../../../../hook/usePlatform';

export interface AcceptButtonProps {
  historyId:number;
  showButton:boolean;
}
const AcceptButton:React.FC<AcceptButtonProps> = (props) => {
  const [show, setShow] = useState(props.showButton);
  const navigate = useNavigate();
  const { user } = useAuth();
  const isMobile = useMobile();
  const onAcceptOrDenied = async (isAccept:boolean) => {
    await setIsAccept(isAccept, props.historyId, user!.memberId);
    if (isAccept) {
      setShow(false);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <SubButton
        text="거부하기"
        onPress={() => {
          if (window.confirm('프로필을 거부하시겠어요?\n거부 시 해당 프로필을 다시 볼 수 없어요')) {
            onAcceptOrDenied(false).then((r) => {
              alert('거부처리 되었습니다.');
              navigate(-1);
            });
          }
        }}
        style={{ flex: 1, paddingBlock: 10, paddingInline: 0 }}
      />
      <MainButton
        text="수락하기"
        onPress={() => {
          if (window.confirm('프로필을 수락하시겠어요?')) {
            onAcceptOrDenied(true).then((r) => {
              alert('수락처리 되었습니다.');
            });
          }
        }}
        style={{ flex: 1, paddingBlock: 10, paddingInline: 0 }}
      />
    </div>
  );
};

export default AcceptButton;
